import React from "react";
import { Engine } from "excalibur";
import DebugPane from "./DebugPane";

interface MobileDebugOverlayProps {
  game: Engine;
  isOpen: boolean;
  onClose: () => void;
}

const MobileDebugOverlay: React.FC<MobileDebugOverlayProps> = ({
  game,
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-40 flex items-center justify-center
                    hidden max-[768px]:flex pointer-events-auto"
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />

      {/* Modal Content */}
      <div className="relative bg-white rounded-lg shadow-xl mx-4 my-8 w-full max-w-sm max-h-[80vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800">Game Saves</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl font-bold w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100"
          >
            ×
          </button>
        </div>

        {/* DebugPane Content */}
        <div className="p-4 overflow-y-auto max-h-[60vh]">
          <DebugPane game={game} />
        </div>
      </div>
    </div>
  );
};

export default MobileDebugOverlay;
